import { SHOW_LOGIN_DIALOG, LOGIN_USER_NOT_FOUND, LOGIN_INCORRECT_CREDENTIALS ,LOGIN_SUCCESS, LOGIN_PASSWORD_RESET} from "../actions/types";

const loginDialog =  (state = false, action) => {
  switch (action.type) {
    case SHOW_LOGIN_DIALOG:
      return action.isActive;
    default:
      return state;
  }
};


const loginDialogInfo =  (state = null, action) => {
  switch (action.type) {
    case LOGIN_USER_NOT_FOUND:
      return action.error || null;
    case LOGIN_INCORRECT_CREDENTIALS:
      return action.error || null;
    case LOGIN_SUCCESS:
      return action.info;
    case LOGIN_PASSWORD_RESET:
      return action.info
    default:
      return state;
  }
};


export default {
  loginDialog,
  loginDialogInfo
}



// WEBPACK FOOTER //
// ./src/reducers/loginReducer.js